module.exports = __webpack_public_path__ + "media/images/iconUp__accent--dark-0dbffb0759ca091f64827f3a7c0561b9.png";